"use client";
import { EyeOff, Highlighter, ZoomIn } from "lucide-react";

interface ToolBarProps {
  currentTool: "highlight" | "zoom" | "blur" | null;
  onToolSelect: (tool: "highlight" | "zoom" | "blur" | null) => void;
}

export function ToolBar({ currentTool, onToolSelect }: ToolBarProps) {
  const tools = [
    {
      icon: Highlighter,
      tool: "highlight" as const,
      label: "Highlight",
      activeBg: "bg-amber-100",
      activeIcon: "text-amber-600",
      activeBorder: "border-amber-200",
      inactiveBg: "bg-white",
      inactiveIcon: "text-slate-400",
    },
    {
      icon: EyeOff,
      tool: "blur" as const,
      label: "Blur",
      activeBg: "bg-purple-100",
      activeIcon: "text-purple-600",
      activeBorder: "border-purple-200",
      inactiveBg: "bg-white",
      inactiveIcon: "text-slate-400",
    },
    {
      icon: ZoomIn,
      tool: "zoom" as const,
      label: "Zoom",
      activeBg: "bg-indigo-100",
      activeIcon: "text-indigo-600",
      activeBorder: "border-indigo-200",
      inactiveBg: "bg-white",
      inactiveIcon: "text-slate-400",
    },
  ] as const;

  return (
    <div className="w-20 flex flex-col items-center gap-6 py-4">
      {tools.map(
        ({
          icon: Icon,
          tool,
          label,
          activeBg,
          activeIcon,
          activeBorder,
          inactiveBg,
          inactiveIcon,
        }) => (
          <div key={tool} className="flex flex-col items-center gap-2">
            <button
              className={`
                relative w-14 h-14 rounded-2xl transition-all duration-300
                flex items-center justify-center group
                border
                ${currentTool === tool
                  ? `${activeBg} ${activeIcon} ${activeBorder} shadow-lg shadow-indigo-100`
                  : `${inactiveBg} ${inactiveIcon} border-slate-200 hover:border-indigo-200 hover:bg-slate-50 shadow-sm`
                }
              `}
              onClick={() => onToolSelect(currentTool === tool ? null : tool)}
              title={label}
            >
              <Icon size={24} className="transition-transform group-hover:scale-110" />

              {currentTool === tool && (
                <div className="absolute -left-3 w-1.5 h-6 bg-indigo-600 rounded-r-full" />
              )}
            </button>

            <span
              className={`text-[10px] font-bold uppercase tracking-wider transition-colors ${currentTool === tool
                  ? activeIcon
                  : "text-slate-400"
                }`}
            >
              {label}
            </span>
          </div>
        )
      )}
    </div>
  );
}
